import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=1b40640c&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=js"
export * from "./UserCard.vue?vue&type=script&lang=js"
import style0 from "./UserCard.vue?vue&type=style&index=0&id=1b40640c&prod&lang=css"
import style1 from "./UserCard.vue?vue&type=style&index=1&id=1b40640c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b40640c",
  null
  
)

export default component.exports